import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Store, select } from "@ngrx/store";
import { State } from "../vista-usuario/vista-usuario.state";
import { Observable } from "rxjs";
import { selectAuthPersona } from "../persona/entity-personas/entity-personas.selectors";
import { map } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class PersonaActualizadaGuard implements CanActivate {
  constructor(
    private router: Router,
    private store: Store<State>,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const c1 = this.store.pipe(select(selectAuthPersona))
      .pipe(
        map((authPersona) => {
          if (authPersona?.actualizado === false) {
            this.router.navigate(['/perfil'])
            return false
          } else {
            return true
          }
        })
      )

    return c1
  }
}
